/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import './SearchActionBarOverlay.scss';

import * as React from 'react';
import { Button, Icon } from 'sarsaparilla';

interface SearchActionBarOverlayProps {
    onToggle: (isListView: boolean) => void;
    showMapButtonRef?: React.Ref<HTMLButtonElement | HTMLAnchorElement>;
}

export function SearchActionBarOverlay({
    onToggle,
    showMapButtonRef,
}: SearchActionBarOverlayProps) {
    return (
        <div className="search--map-bar-overlay" data-testid="map-search-bar-overlay">
            <div className="inner">
                <Button
                    ref={showMapButtonRef}
                    shouldFitContainer
                    size="sm"
                    onClick={() => {
                        onToggle(false);
                    }}
                    iconBeforeElement={<Icon iconName="pin" />}
                    gaTrackingId="185094153802"
                    gaTrackingValue="Show Map on Mobile"
                    appearance="primary"
                    className="show-map-button"
                >
                    Show Map
                </Button>
            </div>
        </div>
    );
}
